import React, { useContext } from 'react'
import axios from 'axios'
import { SiteContext } from '../../context/siteContext'
import { FilterContext } from '../../context/filterContext'
import Distance from './Distance'
import styles from './category.module.css'
import { FaFilter } from 'react-icons/fa'

export default function Categories(props) {

    const { setMarkers } = useContext(SiteContext);
    const { filterData } = useContext(FilterContext);

    const filter = async (category) => {
        // await axios.post(`http://localhost:5000/tubbees/filter/${category}`).then((res) => {
        //     setMarkers(res.data)
        // }).catch((err) => {
        //     console.log(err)
        // })

        const isOpen = async () => {
            await axios.get(`https://maps.rt-itservices.co.uk/open?site=Tubbees`).then((res) => {
                setMarkers(res.data.sites)
            }).catch((err) => {
                console.log(err)
            })
        }
        var filtD;
        switch (category) {
            case "dessert":
                filtD = filterData.filter((site) => site.utilities.DessertLab);
                setMarkers(filtD);
                break;
            case "nitro":
                filtD = filterData.filter((site) => site.utilities.NitroLab);
                setMarkers(filtD);
                break;
            case "open":
                isOpen();
                // filtD = filterData.filter((site) => site.utilities.DessertLab);
                // setMarkers(filtD);
                break;
            case "takeaway":
                filtD = filterData.filter((site) => site.takeaway);
                setMarkers(filtD);
                break;
            case "sitin":
                filtD = filterData.filter((site) => site.sitIn);
                setMarkers(filtD);
                break;
            default:
                setMarkers(filterData);
        }
    }


    return (
        <>
            {props.brand === "Tubbees" ?
                <>
                    {props.bigScreen ?
                        <div className={`p-2 ${styles.bar} ${styles.image}`}>
                            <h3 className={`${styles.message}`}><u>Filter<FaFilter /></u></h3>
                            <hr />
                            <button className={`my-3 w-100 p-1 ${styles.category}`} onClick={() => filter("all")}>All Stores</button>
                            <button className={`my-3 w-100 p-1 ${styles.category}`} onClick={() => filter("dessert")}>Dessert Lab</button>
                            <button className={`my-3 w-100 p-1 ${styles.category}`} onClick={() => filter("nitro")}>Nitro Lab</button>
                            <button className={`my-3 w-100 p-1 ${styles.category}`} onClick={() => filter("open")}>Open Now</button>
                            <button className={`my-3 w-100 p-1 ${styles.category}`} onClick={() => filter("takeaway")}>Takeaway</button>
                            <button className={`my-3 w-100 p-1 ${styles.category}`} onClick={() => filter("sitin")}>Sit-In</button>
                            <hr />
                            <Distance brand={props.brand} big={true} />
                            <hr />
                        </div>
                        :
                        <div className={`p-3 ${styles.bar} ${styles.image}`}>
                            <h3 className={`${styles.message}`}><u>Filter<FaFilter /></u></h3>
                            <hr />
                            <div className="row">
                            <button className={`col mx-1 my-3 p-1 ${styles.category}`} onClick={() => filter("all")}>All Stores</button>
                            <button className={`col mx-1 my-3 p-1 ${styles.category}`} onClick={() => filter("dessert")}>Dessert Lab</button>
                            <button className={`col mx-1 my-3 p-1 ${styles.category}`} onClick={() => filter("nitro")}>Nitro Lab</button>
                            <button className={`col mx-1 my-3 p-1 ${styles.category}`} onClick={() => filter("open")}>Open Now</button>
                            {/* <button className={`col-2 mx-1 my-3 p-1 ${styles.category}`} onClick={() => filter("takeaway")}>Take-away</button> */}
                            <button className={`col mx-1 my-3 p-1 ${styles.category}`} onClick={() => filter("sitin")}>Sit-In</button>
                            </div>
                            <hr />
                            <Distance brand={props.brand} big={false} />
                            <hr />
                        </div>
                    }
                </>
                : 
                <>
                {props.bigScreen ?
                        <div className={`p-2 ${styles.bar} ${styles.image}`}>
                            <h3 className={`${styles.message}`}><u>Filter<FaFilter /></u></h3>
                            <hr />
                            <button className={`my-3 w-100 p-1 ${styles.category}`} onClick={() => filter("all")}>All Stores</button>
                            <button className={`my-3 w-100 p-1 ${styles.category}`} onClick={() => filter("open")}>Open Now</button>
                            <hr />
                            <Distance brand={props.brand} big={true} />
                            <hr />
                        </div>
                        :
                        <div className={`p-2 ${styles.bar} ${styles.image}`}>
                            <h3 className={`${styles.message}`}><u>Filter<FaFilter /></u></h3>
                            <hr />
                            <button className={`col-2 my-3 p-1 ${styles.category}`} onClick={() => filter("all")}>All Stores</button>
                            <button className={`col-2 my-3 p-1 ${styles.category}`} onClick={() => filter("open")}>Open Now</button>
                            <hr />
                            <Distance brand={props.brand} big={false} />
                            <hr />
                        </div>
                    }
                </>
            }
        </>

    )
}
